import {Injectable, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AlertsService} from './alerts.service';
import {HeaderService} from './header.service';
import { WindowRef } from "./windowRef";
import { APPCUE_STORAGE_KEY } from '../../config'
import {environment} from "../../../environments/environment";

@Injectable()
export class Globals implements OnInit{
  [x: string]: any;

  assets_url : string = '';   // path till assets folder used in cdn
  table_delete_icon : string = ''; // icon path for delete in ng-table
  username: any;
  role = 'live';
  product_type = '';
  wa_timezone = '';
  globalDomain = 'all';
  selected = 'all';
  clientid : number;
  full_name : string;
  emailid : string;
  contact_email: any;    // email id of user wheteher master or role user login
  smartechEnable: boolean;
  is_mmlite_enabled: boolean = false;
  // fetch MMLite status only once
  shouldFetchMMLiteStatus: boolean = true;

  constructor(private router: Router,
              private alertsService: AlertsService,
              private headerService: HeaderService,
              private winRef : WindowRef) {

      if( environment.cdn_present ){
        this.assets_url = environment.cdn_url;
      }
      this.headerService.productType$.subscribe(value => {
        this.product_type = value


      });
  }


  ngOnInit() {

  }

  setMode(mode) {
    this.role = mode;
    this.alertsService.refreshPage();
    // this.globals.changeMode(mode, this.router.url);
  }

  changeMode(mode, url) {
    this.role = mode;
    if (url.includes('/analytics/mail-summary') || url.includes('/live') || url.includes('/dashboard')) {
      this.router.navigate([url]);
    } else {
      this.router.navigate(['/analytics/mail-summary']);
    }
  }

  // Below code for Appcues Integration -Addded By Akshay @ conatct - akshay.jadhav@pepipost.com

  isAppcueLoaded( ) {
    return ( ( this.winRef.nativeWindow.analytics && this.winRef.nativeWindow.analytics != null ) ? true : false );
  }

  /* set login user's data as it will be called everytime when dashboard page gets call need to change
  so that one time while after only successful login will call this function */
  setClientProfile( profile ){
      this.clientid  = profile.clientid || 0;
      //this.clientid  = Math.floor((Math.random() * 10000000) + 1);
      //this.clientid  = 9999999999;
      this.full_name = profile.f_name + " " + profile.l_name;
      this.emailid   = profile.emailid;
      this.username  = profile.username;
      this.contact_email = profile.contact_email;
      //this.identifyAppcue( );    // also set user id with appcue
  }

  // use settled user profile to initialize Appcue with user
  identifyAppcue( ){
    if( this.isAppcueLoaded( ) && this.clientid != 0 ){
      this.winRef.nativeWindow.analytics.identify( this.clientid, {
        'name'     : this.full_name,
        'email'    : this.emailid,
        'username' : this.username
      })
    }
  }

  // track user wise event
  trackAppcueEvent( evt_name : string ){
    this.winRef.nativeWindow.analytics.track( evt_name );
  }

  // As this framwork is angular we need to call below function to trigger page change
  triggerPageChange( ){
    this.winRef.nativeWindow.analytics.page( );
  }

  setLocalStorage( key : any, val : string ) {
    if (typeof( Storage ) !== "undefined") {
      if( key == '' || key == null ){
        key = APPCUE_STORAGE_KEY + this.clientid;
      }
      let appc_storage = this.getLocalStorage( '' );
      let oldItems = ( ( appc_storage != '' ) ? JSON.parse( appc_storage ) : [] );
      if( val.trim() != '' ){

        oldItems.push( val );   // add new event
      }
      window.localStorage.setItem( key, JSON.stringify( oldItems ) )
    } else {
    }
  }

  getLocalStorage( key : any ){
    if (typeof( Storage ) !== "undefined") {
      if( key == '' || key == null ){
        key = APPCUE_STORAGE_KEY + this.clientid;
      }
      return window.localStorage.getItem( key ) || "";
      //return storage;
    } else {
    }
  }

  isAppcueEventLocaly( evt_name : string ){

    let appc_storage = this.getLocalStorage( '' );
    appc_storage = ( ( appc_storage != '' ) ? JSON.parse( appc_storage ) : [] );
    if( appc_storage && appc_storage.length > 0 ){
      return ( ( appc_storage.indexOf( evt_name ) != -1 ) ? true : false );
    }else{
      return false;
    }

  }

  public getAssetsUrl ( ) : string {
    return this.assets_url;
  }

  public getTableDeleteIcon ( ) : string {
    return this.assets_url + 'assets/images/delete.svg';
  }

  public getTablePreviewIcon ( ) : string {
    return this.assets_url + 'assets/images/delete.svg';
  }

  public getTableCopyIcon ( ) : string {
    return this.assets_url + 'assets/images/delete.svg';
  }

  public getDownloadIcon ( ) : string {
    return this.assets_url + 'assets/images/download.png';
  }

  public getDownloadConfirmImg2 ( ) : string {
    return this.assets_url + 'assets/images/confirmation2.jpg';
  }

  public getDownloadConfirmImg ( ) : string {
    return this.assets_url + 'assets/images/confirm_illustration.svg';
  }

  public getDownloadConfirmImg3 ( ) : string {
    return this.assets_url + 'assets/images/confirmation.png';
  }

  public getDeleteConfirmImg ( ) : string {
    return this.assets_url + 'assets/images/new-illustration/delete_illustration2.jpg';
  }

  public setCEE(data: boolean) {
    this.smartechEnable = data;
 }

  setDataToLocalStorage(key: string, val: any) {
    window.localStorage.setItem(key, JSON.stringify(val));
  }

  getDataFromLocalStorage(key: string) {
    const item = window.localStorage.getItem(key);
    if (item) {
      return JSON.parse(item);
    }
    return null;
  }

  clearDataFromLocalStorage(key: string) {
    window.localStorage.removeItem(key);
  }
}
